

// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
import { IApiAction } from './payer-onboarding-data-service';
export interface GetAppContentCardResponse {
	Data: AppContentCardModel[];
}
export interface AppContentCardModel {
	Id: string;
	CardType: AppContentCardType;
	ImageUrl: string;
	Title: string;
	Subtitle: string;
	Summary: string;
	TabName: string;
	IsFeatured: boolean;
	EventStartTime?: Date | null;
	EventEndTime?: Date | null;
	EventAllDay: boolean;
}
export enum AppContentCardType {
	Unknown = 0, Default = 1, Video = 2, Audio = 3, Event = 4,
}
export interface ConfirmAchAccountRequest {
	MerchantHandle: string | null;
	InvitationToken: string | null;
	RoutingNumber: string;
	AccountNumber: string;
	AccountType: AchAccountType;
}
export enum AchAccountType {
	Checking = 1, Savings = 2,
}
export interface AddAchPaymentMethodRequest {
	MerchantHandle: string | null;
	InvitationToken: string | null;
	RoutingNumber: string;
}
export interface AddAchPaymentMethodErrorResponse {
	Success: false;
	InvalidRoutingNumber: boolean;
}
export interface AddAchPaymentMethodResponse {
	Success: true;
	BankName: string;
}
export interface AddCreditCardPaymentMethodRequest {
	MerchantHandle: string | null;
	InvitationToken: string | null;
	CardNumber: string;
	CardExpirationMonth: string;
	CardExpirationYear: string;
	CardSecurity: string;
	ZipCode: string;
}
export interface AddPaymentMethodErrorResponse {
	Success: false;
	ResultCode: AddPaymentMethodResultCode;
	ErrorMessage: string[];
}
export enum AddPaymentMethodResultCode {
	Unknown = 0, Succeeded = 1, UserCorrectableError = 2, CardTokenizationUnavailable = 3,
}
export interface AddPaymentMethodResponse {
	Success: true;
	ResultCode: AddPaymentMethodResultCode;
}
export interface GiveNowRequest {
	MerchantHandle: string;
	LoginToken: string;
	InvitationToken: string;
}
export interface GiveNowResponse {
	ReturnUrl: string;
}
export interface LoginRequest {
	LoginToken: string;
	InvitationToken: string;
}
export interface LoginResponse {
	ReturnUrl: string;
}
export interface PageStatsRequest {
	PageName: string;
	Timestamp: Date;
	InvitationToken: string | null;
}
export interface ConfirmCodeAndUpdateDetailsRequest {
	MerchantHandle: string | null;
	BrowserTimeZone: string | null;
	InvitationToken: string | null;
	Code: string;
	RequestToken: string;
	FirstName: string;
	LastName: string;
	Email: string;
}
export interface ConfirmCodeAndUpdateDetailsErrorResponse {
	Success: false;
	ConfirmationCodeInvalid: boolean;
	Reason: ResetPageReason;
	Message: string;
}
export interface ConfirmCodeAndUpdateDetailsResponse {
	Success: true;
	LoginToken: string;
	IdentityToken: string;
	PersonCountryInfo: PersonCountryInfo;
	AppConnectData: string;
	AppLinkSMSHasBeenSent: boolean;
}
export interface PersonCountryInfo {
	CountryCode: Country;
	PostalCodeCommonName: string;
}
export enum Country {
	NZ = 0, AU = 1, US = 2, AF = 4, AL = 8, AQ = 10, DZ = 12, AS = 16, AD = 20, AO = 24, AG = 28, AZ = 31, AR = 32, AT = 40, BS = 44, BH = 48, BD = 50, AM = 51, BB = 52, BE = 56, BM = 60, BT = 64, BO = 68,
	BA = 70, BW = 72, BV = 74, BR = 76, BZ = 84, IO = 86, SB = 90, VG = 92, BN = 96, BG = 100, MM = 104, BI = 108, BY = 112, KH = 116, CM = 120, CA = 124, CV = 132, KY = 136, CF = 140, LK = 144, TD = 148, CL = 152,
	CN = 156, TW = 158, CX = 162, CC = 166, CO = 170, KM = 174, YT = 175, CG = 178, CD = 180, CK = 184, CR = 188, HR = 191, CU = 192, CY = 196, CZ = 203, BJ = 204, DK = 208, DM = 212, DO = 214, EC = 218, SV = 222,
	GQ = 226, ET = 231, ER = 232, EE = 233, FO = 234, FK = 238, GS = 239, FJ = 242, FI = 246, AX = 248, FR = 250, GF = 254, PF = 258, TF = 260, DJ = 262, GA = 266, GE = 268, GM = 270, PS = 275, DE = 276, GH = 288,
	GI = 292, KI = 296, GR = 300, GL = 304, GD = 308, GP = 312, GU = 316, GT = 320, GN = 324, GY = 328, HT = 332, HM = 334, VA = 336, HN = 340, HK = 344, HU = 348, IS = 352, IN = 356, ID = 360, IR = 364, IQ = 368,
	IE = 372, IL = 376, IT = 380, CI = 384, JM = 388, JP = 392, KZ = 398, JO = 400, KE = 404, KP = 408, KR = 410, KW = 414, KG = 417, LA = 418, LB = 422, LS = 426, LV = 428, LR = 430, LY = 434, LI = 438, LT = 440,
	LU = 442, MO = 446, MG = 450, MW = 454, MY = 458, MV = 462, ML = 466, MT = 470, MQ = 474, MR = 478, MU = 480, MX = 484, MC = 492, MN = 496, MD = 498, ME = 499, MS = 500, MA = 504, MZ = 508, OM = 512, NA = 516,
	NR = 520, NP = 524, NL = 528, CW = 531, AW = 533, SX = 534, BQ = 535, NC = 540, VU = 548, NI = 558, NE = 562, NG = 566, NU = 570, NF = 574, NO = 578, MP = 580, UM = 581, FM = 583, MH = 584, PW = 585, PK = 586,
	PA = 591, PG = 598, PY = 600, PE = 604, PH = 608, PN = 612, PL = 616, PT = 620, GW = 624, TL = 626, PR = 630, QA = 634, RE = 638, RO = 642, RU = 643, RW = 646, BL = 652, SH = 654, KN = 659, AI = 660, LC = 662,
	MF = 663, PM = 666, VC = 670, SM = 674, ST = 678, SA = 682, SN = 686, RS = 688, SC = 690, SL = 694, SG = 702, SK = 703, VN = 704, SI = 705, SO = 706, ZA = 710, ZW = 716, ES = 724, SS = 728, SD = 729, EH = 732,
	SR = 740, SJ = 744, SZ = 748, SE = 752, CH = 756, SY = 760, TJ = 762, TH = 764, TG = 768, TK = 772, TO = 776, TT = 780, AE = 784, TN = 788, TR = 792, TM = 795, TC = 796, TV = 798, UG = 800, UA = 804, MK = 807,
	EG = 818, GB = 826, GG = 831, JE = 832, IM = 833, TZ = 834, VI = 850, BF = 854, UY = 858, UZ = 860, VE = 862, WF = 876, WS = 882, YE = 887, ZM = 894, XK = 999, __ = -2, Unsupported = -1,
}
export interface ResendConfirmationCodeRequest {
	MerchantHandle: string | null;
	InvitationToken: string | null;
	NormalizedInternationalNumber: string;
	UseVoiceCall?: boolean | null;
}
export interface EnterMobileNumberRequest {
	MerchantHandle: string | null;
	InvitationToken: string | null;
	MobileNumber: string;
	Country: string;
	UseVoiceCall?: boolean | null;
}
export interface EnterMobileNumberErrorResponse {
	Success: false;
	Reason: InvalidMobileNumberReason;
	Message: string;
	LoginUrl: string;
}
export enum InvalidMobileNumberReason {
	Unknown = 0, InvalidCountry = 1, MobileNumberInUse = 2, UnableToParse = 3, ConfirmCodeFailed = 4,
}
export interface EnterMobileNumberResponse {
	MobileNumber: PayerOnboardingMobileNumber;
	RequestToken: string;
	Success: true;
}
export interface PayerOnboardingMobileNumber {
	NormalizedInternationalNumber: string;
	NationalNumber: string;
}
export enum ResetPageReason {
	Unknown = 0, PersonNotFound = 1, DuplicateMobileNumber = 3,
}
export interface PayerOnboardingViewModel {
	Theme: Theme;
	MerchantInfo: PayerOnboardingMerchantInfo;
	PersonInfo: PayerOnboardingPersonInfo | null;
	PushpayInfo: PayerOnboardingPushpayInfo;
	BrandingPackage: BrandingPackage | null;
	GoogleAnalyticsTrackerId: string;
	InvitationToken: string | null;
	SessionCorrelationId: string;
	SkipAddPaymentMethod: boolean;
}
export interface BrandingPackage {
	Version: string | null;
	HeroImageUrl: string | null;
	HeroImageKey: string | null;
	EnhancedLogoImageUrl: string | null;
	EnhancedLogoImageKey: string | null;
	FaviconImageUrl: string | null;
	FaviconImageKey: string | null;
	GivingTitle: string | null;
	PrimaryColor: string;
	SecondaryColor: string;
	RetrievedAt: Instant;
	ETag: string | null;
}
export interface Instant {
}
export interface PayerOnboardingPushpayInfo {
	TermsAndConditions: string;
	PrivacyPolicy: string;
	HelpCenterLink: string;
}
export interface PayerOnboardingPersonInfo {
	FirstName: string;
	LastName: string;
	MobileNumber: string | null;
}
export interface PayerOnboardingMerchantInfo {
	TradingName: string;
	LegalName: string;
	Address: string;
	Country: Country;
	LogoUrl: string;
	WebsiteUrl: string;
	Handle: string;
	PaymentLabel: PaymentLabel;
	TermsAndConditions: string;
	PrivacyPolicy: string;
	SupportedCardBrandKeys: string[];
	PaymentMethodPreference: PaymentMethodType;
	CardPreference?: MerchantCardPreference | null;
	SupportsAch: boolean;
	IsDefaultMerchant: boolean;
	MobileAppName: string;
	HasCustomApp: boolean;
	GetAppUrl: string;
}
export enum MerchantCardPreference {
	AnyCard = 0, DebitPreferred = 1, DebitOnly = 2,
}
export enum PaymentMethodType {
	Unknown = 0, CreditCard = 1, NzBankAccount = 2, ACH = 3, Cash = 4, RecordedCheck = 5, AchCheck = 6, ProfitStarsScannedCheck = 7, RecordedCreditCard = 8, RecordedACH = 9, ImportedUnspecified = 10, ImportedUnsupported = 11,
}
export interface PaymentLabel {
	NounSentenceCase: string;
	NounPluralSentenceCase: string;
	VerbSentenceCase: string;
	VerbAppliedSentenceCase: string;
	NounLowerCase: string;
	NounPluralLowerCase: string;
	VerbLowerCase: string;
	VerbAppliedLowerCase: string;
	VerbPresentTenseSentenceCase: string;
	VerbPresentTenseLowerCase: string;
	VerbPastTenseSentenceCase: string;
	VerbPastTenseLowerCase: string;
	PayerSentenceCase: string;
	PayerLowerCase: string;
	PayerPluralSentenceCase: string;
	PayerPluralLowerCase: string;
	ActionSentenceCase: string;
	ActionLowerCase: string;
	ActionPluralSentenceCase: string;
	ActionPluralLowerCase: string;
	NonCashNounSentenceCase: string;
	NonCashNounLowerCase: string;
	NonCashPluralSentenceCase: string;
	NonCashPluralLowerCase: string;
	TextGivingFeatureName: string;
	GiftEntryFeatureName: string;
}
export interface Theme {
	PrimaryColor: string;
	SecondaryColor: string;
	Nonce: string;
	MerchantLogoUrl: string;
	ReturnUrl: string;
	ReturnLabel: string;
}
export const PayerOnboardingApiConfig = {
	defaultBaseUrl: () => (<RegExpMatchArray>location.pathname.match(new RegExp('/onboarding', 'i')))[0],
	actions: {
		enterMobileNumber: <IApiAction<{model: EnterMobileNumberRequest}, EnterMobileNumberResponse | EnterMobileNumberErrorResponse>>{
			url: (data) => `/EnterMobileNumber`,
		},
		resendConfirmationCode: <IApiAction<{model: ResendConfirmationCodeRequest}, EnterMobileNumberResponse | EnterMobileNumberErrorResponse>>{
			url: (data) => `/ResendConfirmationCode`,
		},
		confirmCodeAndUpdateDetails: <IApiAction<{model: ConfirmCodeAndUpdateDetailsRequest}, ConfirmCodeAndUpdateDetailsResponse | ConfirmCodeAndUpdateDetailsErrorResponse>>{
			url: (data) => `/ConfirmCodeAndUpdateDetails`,
		},
		recordPageStats: <IApiAction<{model: PageStatsRequest}>>{
			url: (data) => `/onboardingRecordPageStats`,
		},
		login: <IApiAction<{model: LoginRequest}, LoginResponse>>{
			url: (data) => `/Login`,
		},
		giveNow: <IApiAction<{model: GiveNowRequest}, GiveNowResponse>>{
			url: (data) => `/GiveNow`,
		},
		addCreditCardPaymentMethod: <IApiAction<{model: AddCreditCardPaymentMethodRequest}, AddPaymentMethodResponse | AddPaymentMethodErrorResponse>>{
			url: (data) => `/AddCreditCardPaymentMethod`,
		},
		addAchPaymentMethod: <IApiAction<{model: AddAchPaymentMethodRequest}, AddAchPaymentMethodResponse | AddAchPaymentMethodErrorResponse>>{
			url: (data) => `/AddAchPaymentMethod`,
		},
		confirmAchAccount: <IApiAction<{model: ConfirmAchAccountRequest}, AddPaymentMethodResponse | AddPaymentMethodErrorResponse>>{
			url: (data) => `/ConfirmAchAccount`,
		},
		getAppContentCards: <IApiAction<{}, GetAppContentCardResponse>>{
			url: (data) => `/onboardingGetAppContentCards`,
		},
	},
	urls: {
	},
};
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export namespace ModelMetadata {
	export class MetadataArrayOf<T> {
		metadata: T;

		constructor(metadata: T) {
			this.metadata = metadata;
		}

		at(index: number): T {
			return this.metadata;
		}
	}

	export interface IPropertyMetadata {
		propertyName: string;
		displayName?: string;
		placeholder?: string;
		validationRules?: { [rule: string]: any };
		modelMetadata?: { [name: string] :IPropertyMetadata};
	}

	export let EnterMobileNumberRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
		MobileNumber: {
			propertyName: "MobileNumber",
			displayName: "Mobile",
			placeholder: "e.g. 555 123 4567",
			validationRules: {
				length: {
					errorMessage: "This number is not valid",
					parameters: {
						max: 20,
						min: 5,
					},
				},
				required: {
					errorMessage: "Please enter mobile number",
				},
				skipsanitization: {},
			},
		},
		Country: {
			propertyName: "Country",
			validationRules: {
				length: {
					errorMessage: "The field Country must be a string with a maximum length of 2.",
					parameters: {
						max: 2,
					},
				},
				required: {
					errorMessage: "The Country field is required.",
				},
			},
		},
		UseVoiceCall: {
			propertyName: "UseVoiceCall",
		},
	};
	export let ResendConfirmationCodeRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
		NormalizedInternationalNumber: {
			propertyName: "NormalizedInternationalNumber",
			validationRules: {
				length: {
					errorMessage: "The field NormalizedInternationalNumber must be a string with a minimum length of 9 and a maximum length of 20.",
					parameters: {
						max: 20,
						min: 9,
					},
				},
				required: {
					errorMessage: "The NormalizedInternationalNumber field is required.",
				},
				skipsanitization: {},
			},
		},
		UseVoiceCall: {
			propertyName: "UseVoiceCall",
		},
	};
	export let ConfirmCodeAndUpdateDetailsRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		BrowserTimeZone: {
			propertyName: "BrowserTimeZone",
			validationRules: {
				length: {
					errorMessage: "The field BrowserTimeZone must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
		Code: {
			propertyName: "Code",
			displayName: "Confirmation Code",
			placeholder: "e.g. 123456",
			validationRules: {
				length: {
					errorMessage: "Please enter a 6 digit security code",
					parameters: {
						max: 6,
						min: 6,
					},
				},
				required: {
					errorMessage: "Please enter a 6 digit security code",
				},
			},
		},
		RequestToken: {
			propertyName: "RequestToken",
			validationRules: {
				length: {
					errorMessage: "The field RequestToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				required: {
					errorMessage: "The RequestToken field is required.",
				},
				skipsanitization: {},
			},
		},
		FirstName: {
			propertyName: "FirstName",
			placeholder: "e.g. James",
			validationRules: {
				length: {
					errorMessage: "This name is not valid",
					parameters: {
						max: 100,
					},
				},
				required: {
					errorMessage: "Please enter first name",
				},
			},
		},
		LastName: {
			propertyName: "LastName",
			placeholder: "e.g. Smith",
			validationRules: {
				length: {
					errorMessage: "This name is not valid",
					parameters: {
						max: 100,
					},
				},
				required: {
					errorMessage: "Please enter last name",
				},
			},
		},
		Email: {
			propertyName: "Email",
			placeholder: "e.g. james@smith.com",
			validationRules: {
				email: {
					errorMessage: "This email address is not valid",
				},
				length: {
					errorMessage: "This email address is not valid",
					parameters: {
						max: 100,
					},
				},
			},
		},
	};
	export let PageStatsRequest : { [name: string]: IPropertyMetadata } = {
		PageName: {
			propertyName: "PageName",
		},
		Timestamp: {
			propertyName: "Timestamp",
			validationRules: {
				date: {
					errorMessage: "The field Timestamp must be a date.",
				},
				required: {
					errorMessage: "The Timestamp field is required.",
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
	};
	export let LoginRequest : { [name: string]: IPropertyMetadata } = {
		LoginToken: {
			propertyName: "LoginToken",
			validationRules: {
				maxlength: {
					errorMessage: "The field LoginToken must be a string or array type with a maximum length of '200'.",
					parameters: {
						max: 200,
					},
				},
				required: {
					errorMessage: "The LoginToken field is required.",
				},
				skipsanitization: {},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				maxlength: {
					errorMessage: "The field InvitationToken must be a string or array type with a maximum length of '200'.",
					parameters: {
						max: 200,
					},
				},
				skipsanitization: {},
			},
		},
	};
	export let GiveNowRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		LoginToken: {
			propertyName: "LoginToken",
			validationRules: {
				maxlength: {
					errorMessage: "The field LoginToken must be a string or array type with a maximum length of '200'.",
					parameters: {
						max: 200,
					},
				},
				required: {
					errorMessage: "The LoginToken field is required.",
				},
				skipsanitization: {},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				maxlength: {
					errorMessage: "The field InvitationToken must be a string or array type with a maximum length of '200'.",
					parameters: {
						max: 200,
					},
				},
				skipsanitization: {},
			},
		},
	};
	export let AddCreditCardPaymentMethodRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
		CardNumber: {
			propertyName: "CardNumber",
			displayName: "Card",
			placeholder: "●●●● ●●●● ●●●● ●●●●",
			validationRules: {
				length: {
					errorMessage: "The field Card must be a string with a maximum length of 19.",
					parameters: {
						max: 19,
					},
				},
				required: {
					errorMessage: "The Card field is required.",
				},
				skipsanitization: {},
			},
		},
		CardExpirationMonth: {
			propertyName: "CardExpirationMonth",
			displayName: "Expiry",
			placeholder: "●●",
			validationRules: {
				length: {
					errorMessage: "The field Expiry must be a string with a minimum length of 1 and a maximum length of 2.",
					parameters: {
						max: 2,
						min: 1,
					},
				},
				required: {
					errorMessage: "The Expiry field is required.",
				},
			},
		},
		CardExpirationYear: {
			propertyName: "CardExpirationYear",
			displayName: "/",
			placeholder: "●●",
			validationRules: {
				length: {
					errorMessage: "The field / must be a string with a minimum length of 2 and a maximum length of 2.",
					parameters: {
						max: 2,
						min: 2,
					},
				},
				required: {
					errorMessage: "The / field is required.",
				},
			},
		},
		CardSecurity: {
			propertyName: "CardSecurity",
			displayName: "CVV",
			validationRules: {
				required: {
					errorMessage: "The CVV field is required.",
				},
			},
		},
		ZipCode: {
			propertyName: "ZipCode",
			displayName: "Zip Code",
			placeholder: "●●●●●",
			validationRules: {
				length: {
					errorMessage: "The field Zip Code must be a string with a maximum length of 10.",
					parameters: {
						max: 10,
					},
				},
				required: {
					errorMessage: "The Zip Code field is required.",
				},
			},
		},
	};
	export let AddAchPaymentMethodRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
		RoutingNumber: {
			propertyName: "RoutingNumber",
			displayName: "Routing number",
			validationRules: {
				length: {
					errorMessage: "This routing number is not valid",
					parameters: {
						max: 9,
						min: 9,
					},
				},
				required: {
					errorMessage: "Please enter a 9 digit routing number",
				},
			},
		},
	};
	export let ConfirmAchAccountRequest : { [name: string]: IPropertyMetadata } = {
		MerchantHandle: {
			propertyName: "MerchantHandle",
			validationRules: {
				length: {
					errorMessage: "The field MerchantHandle must be a string with a maximum length of 50.",
					parameters: {
						max: 50,
					},
				},
			},
		},
		InvitationToken: {
			propertyName: "InvitationToken",
			validationRules: {
				length: {
					errorMessage: "The field InvitationToken must be a string with a maximum length of 60.",
					parameters: {
						max: 60,
					},
				},
				skipsanitization: {},
			},
		},
		RoutingNumber: {
			propertyName: "RoutingNumber",
			displayName: "Routing number",
			placeholder: "●●●●●●●●●",
			validationRules: {
				length: {
					errorMessage: "This routing number is not valid",
					parameters: {
						max: 9,
						min: 9,
					},
				},
				required: {
					errorMessage: "Please enter a 9 digit routing number",
				},
			},
		},
		AccountNumber: {
			propertyName: "AccountNumber",
			displayName: "Account number",
			placeholder: "●●●●●●●●●",
			validationRules: {
				length: {
					errorMessage: "This account number is not valid",
					parameters: {
						max: 17,
						min: 4,
					},
				},
				required: {
					errorMessage: "Please enter a 4-17 digit account number",
				},
				skipsanitization: {},
			},
		},
		AccountType: {
			propertyName: "AccountType",
			displayName: "Account type",
			validationRules: {
				required: {
					errorMessage: "Please choose the account type",
				},
			},
		},
	};
}
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
// ReSharper disable InconsistentNaming
// ReSharper disable StringLiteralWrongQuotes
/* tslint:disable:no-use-before-declare quotemark max-line-length */
export type CardBrandConfig = {
	key: string;
	shortName: string;
	friendlyName: string;
	shouldLuhn: boolean;
	pattern: RegExp;
	cvvLength: number;
	cvvMask: any[];
	cvvRegex: RegExp;
	cardNumberMask: any[];
	cardNumberRegex: RegExp;
};
export const CardBrandData: CardBrandConfig[] = [
{
	key: "3",
	shortName: "Amex",
	friendlyName: "American Express",
	shouldLuhn: true,
	pattern: /^3[47]/,
	cvvLength: 4,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{4}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{6} [0-9]{5}$/,
},
{
	key: "4",
	shortName: "Discover",
	friendlyName: "Discover",
	shouldLuhn: true,
	pattern: /^(6011|65|64[4-9]|622)/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/,
},
{
	key: "1",
	shortName: "MasterCard",
	friendlyName: "MasterCard",
	shouldLuhn: true,
	pattern: /^(5[0-5]|2[2-7])/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/,
},
{
	key: "2",
	shortName: "VISA",
	friendlyName: "Visa",
	shouldLuhn: true,
	pattern: /^4/,
	cvvLength: 3,
	cvvMask: [/[0-9]/, /[0-9]/, /[0-9]/],
	cvvRegex: /^[0-9]{3}$/,
	cardNumberMask: [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, ' ', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/],
	cardNumberRegex: /^[0-9]{4} [0-9]{4} [0-9]{4} [0-9]{4}$/,
}];
/* tslint:enable:no-use-before-declare quotemark max-line-length */
// ReSharper restore InconsistentNaming
// ReSharper restore StringLiteralWrongQuotes
